import './setup';
import state from './state';
import getters from './getters';
import mutations from './mutations';
import actions from './actions';
import { RootState } from '../types';
import {Auth} from './types';
import { Module } from 'vuex';

export const auth: Module<Auth, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
